import * as React from 'react';
import WebGLDirector from '../../webGL/WebGLDirector';
import GLComponent from './GLComponent';
import WebGLText from '../../webGL/WebGLText';
import WebGLLineLoop from '../../webGL/shapes/primitives/WebGLLineLoop';
import WebGLLine from '../../webGL/shapes/primitives/WebGLLine';
import Color from '../../webGL/Color';
import WebGLTextOrientation from '../../webGL/WebGLTextOrientation';
import MathComponent from '../../shared/MathComponent';

export default class AnglesComponent extends GLComponent {

	componentDidMount () {
		const director = new WebGLDirector(this.canvas, this.props.width, this.props.height, this.textOverlay);

		director.addShape(WebGLLineLoop.circle(0, 0, .8, 256));

		for (let degrees = 0; degrees <= 360; degrees += 30) {
			const radians = degrees / 180 * Math.PI;
			director.addShape(WebGLLine.fromNumbers(0, 0, Math.cos(radians) * .8, Math.sin(radians) * .8).setColor(Color.cyan()));

			director.addText(new WebGLText(degrees + '°' + (degrees === 0 ? ' or ' : ''), Math.cos(radians) * .8, Math.sin(radians) * .8, degrees === 0 ? WebGLTextOrientation.TOP_LEFT : WebGLTextOrientation.TOP_RIGHT, 4));
			// director.addText(new WebGLText(<MathComponent value={degrees + '^\\circ'}/>, Math.cos(radians) * .8, Math.sin(radians) * .8));
			const [numerator, denominator] = this.simplify(degrees / 30, 6);

			const radiansText = degrees === 0 ? '0' : degrees === 180 ? '\\pi' : degrees === 360 ? 2 + '\\pi' : '\\frac{' + numerator + '}{' + denominator + '}\\pi';
			const content = <MathComponent value={radiansText + '\\text{ rad}' + (degrees === 0 ? '\\text{ or }' : '')} />;
			director.addText(new WebGLText(content, Math.cos(radians) * .8, Math.sin(radians) * .8, degrees === 0 ? WebGLTextOrientation.BOTTOM_LEFT : WebGLTextOrientation.BOTTOM_RIGHT, 4));
		}

		director.addShape(WebGLLine.fromNumbers(0, 0, .8, 0).setColor(Color.green()));
		director.addText(new WebGLText('Initial side', .2, 0));

		director.drawScene();
	}

	private simplify (numerator: number, denominator: number) {
		let lowest = numerator < denominator ? numerator : denominator;

		for (let i = 2; i <= lowest; i++) {
			if (numerator % i === 0 && denominator % i === 0) {
				numerator /= i;
				denominator /= i;
				lowest /= i;
			}
		}

		return [numerator, denominator];
	}
}


// WEBPACK FOOTER //
// ./code/project/pages/components/lesson/WebGL/AnglesComponent.tsx